
<!-- 
VisitLetterModal.vue
功能：產製拜訪函視窗
作者：i9400538 陳博承
完成：2022-02-15
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">與禮同行拜訪函</h3>
        </div>
        <div class="padding-left-8">
          <h4>下載/分享與禮同行拜訪函</h4>
          <!--辦訪函A-->
          <div class="d-line-block">
            <img :src="`${BaseUrl}assets/category/invite_a.jpg`" width="300" alt="拜訪函" />
            <br />
            <button type="button" class="btn btn-primary" @click="download('invite_a.jpg')">下載/分享</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
export default {
  name: "VisitLetterModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["UserInfo", "BaseUrl"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  watch: {
    open: function() {
      this.init();
    }
  },
  data() {
    return {
      pic_url: "" //圖檔路徑
    };
  },
  methods: {
    //下載
    download(file) {
      let url = this.pic_url + file;
      if (this.isBox) {
        this.boxSendUrlString(url);
      } else {
        saveAs(url, file);
      }
    },
    init() {
      //串組圖檔路徑
      let startUrl = "";
      if (
        window.location.href.indexOf("localhost") !== -1 ||
        window.location.href.indexOf("tmycrm") !== -1
      ) {
        startUrl = "https://tmycrm.cathaylife.com.tw/";
      } else if (window.location.href.indexOf("smycrm") !== -1) {
        startUrl = "https://smycrm.cathaylife.com.tw/";
      } else {
        startUrl = "https://mycrm.cathaylife.com.tw/";
      }
      this.pic_url = startUrl + this.BaseUrl + "assets/category/";
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-left-8 {
  padding-left: 8%;
}
.d-line-block {
  text-align: center;
}
</style>